import type { MaterialSapVo } from "@/apis/sap.api";
import SelectMaterialModal from "@/components/SelectMaterialModal";
import { useModalBehavior } from "@/hooks/behaviors";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

type Props = {
  /** 选择完成后的回调 */
  onSelect?: (materials?: MaterialSapVo) => void;
};

export const SearchMaterial = ({ onSelect }: Props) => {
  const { t } = useTranslation("purchaseRequestManagement");
  const { open, openModal, closeModal } = useModalBehavior();

  const handleOk = (materials?: MaterialSapVo[]) => {
    closeModal();
    if (materials && materials.length > 0) {
      onSelect?.(materials[0]);
    }
  };

  return (
    <>
      <Button
        style={{
          marginLeft: 10,
        }}
        type="primary"
        onClick={() => openModal()}
      >
        {t("搜索物料")}
      </Button>

      <SelectMaterialModal
        selectionMode="single"
        open={open}
        onOk={handleOk}
        onClose={closeModal}
      />
    </>
  );
};
